'use strict';

module.exports = {
  Abu: {
    name: '2-Aminobutyric acid diradical',
    mf: 'C4H7NO',
    ocl: { value: 'dazHPBPOEgEInVZjcH@', coordinates: '!BbIu^Kxc|bIu^@Hc|b@H' },
    mass: 85.10463700109551,
    monoisotopicMass: 85.05276384961,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Acet: {
    name: 'Acetyl',
    mf: 'C2H3O',
    ocl: { value: 'gCaHDEeIi`@', coordinates: '!BbOr^@Hb]' },
    mass: 43.04469897995611,
    monoisotopicMass: 43.01838971626,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'H', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  Acm: {
    name: 'Acetamidomethyl',
    mf: 'C3H6NO',
    ocl: { value: 'gGYHDPliJuS@@', coordinates: '!BbOrHWXc|W`BHWP' },
    mass: 72.08596035030448,
    monoisotopicMass: 72.04493881738,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Adao: {
    name: 'Adamantyloxy',
    mf: 'C10H15O',
    ocl: {
      value: 'dc\\H`HAYRVeV^dUGZjjjj@@',
      coordinates: '!B~GND{arJOl^@AsEGHi|pos{WgBaT@',
    },
    mass: 151.2258752025074,
    monoisotopicMass: 151.11229010302,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'O', number: 1 },
    ],
  },
  Aib: {
    name: 'alpha-Aminoisobutyric acid diradical',
    mf: 'C4H7NO',
    ocl: { value: 'dazHPBPOGgEInfZj@@', coordinates: '!BbOw~_xc|bOw~@K\\BbOp' },
    mass: 85.10463700109551,
    monoisotopicMass: 85.05276384961,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Ala: {
    name: 'Alanine diradical',
    mf: 'C3H5NO',
    oneLetter: 'A',
    alternativeOneLetter: 'α',
    ocl: { value: 'gNyDBaxmqR[fZjZ@', coordinates: '!BbOw~_x`BbOw~@H`B' },
    mass: 71.07801959624871,
    monoisotopicMass: 71.03711378515,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Arg: {
    name: 'Arginine diradical',
    mf: 'C6H12N4O',
    oneLetter: 'R',
    alternativeOneLetter: 'ρ',
    ocl: {
      value: 'dkLhPBgSPOEgEInWUijjihr@@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|b@I~PD`B_dAW@d`B',
    },
    mass: 156.18592219918227,
    monoisotopicMass: 156.10111102405,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 1 },
    ],
  },
  Argp: {
    name: 'Arginine triradical',
    mf: 'C6H11N4O',
    ocl: {
      value: 'dglhpHpil@gWDEI[UYZfjji`T@',
      coordinates: '!BvS[M]nL]m_[MW[WvsWN]xAUvT@mEmLMn\\',
    },
    mass: 155.1779814451265,
    monoisotopicMass: 155.09328599182,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 4 },
      { symbol: 'O', number: 1 },
    ],
  },
  Asn: {
    name: 'Asparagine diradical',
    mf: 'C4H6N2O2',
    oneLetter: 'N',
    alternativeOneLetter: 'η',
    ocl: {
      value: 'deeDPBeACqYqR[ezZjZL`@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|R@I~PDb}',
    },
    mass: 114.10280438280381,
    monoisotopicMass: 114.04292744137999,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  Asnp: {
    name: 'Asparagine triradical',
    mf: 'C4H5N2O2',
    ocl: {
      value: 'dmUDpH[E@IEqgqRVvVijjXi@@',
      coordinates: '!Buwtw`gy@Mwta_xa]mvHK\\bWb|',
    },
    mass: 113.09486362874803,
    monoisotopicMass: 113.03510240915,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  Asp: {
    name: 'Aspartic acid diradical',
    mf: 'C4H5NO3',
    oneLetter: 'D',
    alternativeOneLetter: 'δ',
    ocl: {
      value: 'defLPBPYCqYqR[ezZjZL`@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|R@I~PDb}',
    },
    mass: 115.08756534162052,
    monoisotopicMass: 115.02694302429,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Aspp: {
    name: 'Aspartic acid triradical',
    mf: 'C4H4NO3',
    ocl: {
      value: 'dmVLpFcE@IEqgqRVvVijjXi@@',
      coordinates: '!Buwtw`gy@Mwta_xa]mvHK\\bWb|',
    },
    mass: 114.07962458756472,
    monoisotopicMass: 114.01911799206,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 4 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Asu: {
    name: 'alpha-Aminosuberic acid diradical',
    mf: 'C8H13NO3',
    ocl: {
      value: 'dgnLPBP{CqYqR[euVfjjihr@@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|rOq~PDC|_dA@@d`C_d@',
    },
    mass: 171.19403496100773,
    monoisotopicMass: 171.08954328213002,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Asup: {
    name: 'alpha-Aminosuberic acid triradical',
    mf: 'C8H12NO3',
    ocl: {
      value: 'do^LpEcG@IMqoqRVuUejZjjibT@',
      coordinates: '!Bmtw_Gy@OtAOs}@SWREbEvwXc|mrI^Kp',
    },
    mass: 170.18609420695194,
    monoisotopicMass: 170.0817182499,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Boc: {
    name: 't-Butoxycarbonyl',
    mf: 'C5H9O2',
    ocl: { value: 'daxD`DpEeImjZj@@', coordinates: '!BtGt~_}A\\tKw}m}A}WM@' },
    mass: 101.12395611881479,
    monoisotopicMass: 101.06025452921,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 2 },
    ],
  },
  Bom: {
    name: 'Benzyloxymethyl',
    mf: 'C8H9O',
    ocl: {
      value: 'deTH`DAYRUYTYj`@@@',
      coordinates: '!BtEsPO]A\\tOwPWCytCwPOSy',
    },
    mass: 121.15675888470227,
    monoisotopicMass: 121.06533990964,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  Brz: {
    name: '2-Bromobenzyloxycarbonyl',
    mf: 'C8H6BrO2',
    ocl: {
      value: 'dcLDPDpEd\\QImYgWYjB@@@',
      coordinates: '!BbOp~@Hc]bOrHOXc|Oa|~@Hc]bCt~Gp',
    },
    mass: 214.03586932736317,
    monoisotopicMass: 212.95511703252,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 6 },
      { symbol: 'Br', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Bu: {
    name: 'Butyl',
    mf: 'C4H9',
    ocl: { value: 'gJPH@liJuP@', coordinates: '!B@Fp@DpAl@AL' },
    mass: 57.114410373442986,
    monoisotopicMass: 57.07042529007,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
    ],
  },
  Bum: {
    name: 't-Butoxymethyl',
    mf: 'C5H11O',
    ocl: { value: 'gNqHDEeIVjj`@', coordinates: '!B@DL@[@ACPq|@Pvp@' },
    mass: 87.14043270260808,
    monoisotopicMass: 87.08098997409999,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 1 },
    ],
  },
  Bz: {
    name: 'Benzoyl',
    mf: 'C7H5O',
    ocl: {
      value: 'didH`DAYR[e^FX@@@@',
      coordinates: '!BbOp~@H`}b@H~Gx`}bCt~Gp',
    },
    mass: 105.1142599717439,
    monoisotopicMass: 105.03403978072,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 5 },
      { symbol: 'O', number: 1 },
    ],
  },
  Bzl: {
    name: 'Benzyl',
    mf: 'C7H7',
    ocl: { value: 'daD@`@VTeeVz`@@@', coordinates: '!BtEsPo]A\\OgPo]@}Og|' },
    mass: 91.13073655553718,
    monoisotopicMass: 91.05477522561,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
    ],
  },
  Bn: {
    name: 'Benzyl',
    mf: 'C7H7',
    ocl: { value: 'daD@`@VTeeVz`@@@', coordinates: '!BdArPOY@\\wg~POYC]wg|' },
    mass: 91.13073655553718,
    monoisotopicMass: 91.05477522561,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
    ],
  },
  Bzlo: {
    name: 'Benzyloxy',
    mf: 'C7H7O',
    ocl: {
      value: 'didH`HAYRUe^Fh@@@@',
      coordinates: '!BdMvPGI@}dAs^_yC]dMw^_p',
    },
    mass: 107.13014147985547,
    monoisotopicMass: 107.04968984518,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 1 },
    ],
  },
  Cha: {
    name: 'beta-Cyclohexylalanine diradical',
    mf: 'C9H15NO',
    ocl: {
      value: 'dknHPBPOEgEInWe]NZjjjcH@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|Uwpww[y@UwqW_Ky@',
    },
    mass: 153.22184251721796,
    monoisotopicMass: 153.11536410745,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Chxo: {
    name: 'Cyclohexyloxy',
    mf: 'C6H11O',
    ocl: { value: 'daDH`HAYRVU[jjj@@', coordinates: '!BdArPOY@\\wg~POYC]wg|' },
    mass: 99.15116859934332,
    monoisotopicMass: 99.08098997409999,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 1 },
    ],
  },
  Cit: {
    name: 'Citrulline diradical',
    mf: 'C6H11N3O2',
    ocl: {
      value: 'dkODPBdttOEgEInWUijjihr@@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|rHK~PLbBrKw~O|bB',
    },
    mass: 157.170683157999,
    monoisotopicMass: 157.08512660696,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  Citp: {
    name: 'Citrulline triradical',
    mf: 'C6H10N3O2',
    ocl: {
      value: 'dgoDpHJ\\l@gWDEI[UYZfjji`T@',
      coordinates: '!BuxKWo_xuxKWo_xu{ta_xa]mvHK\\bWb|',
    },
    mass: 156.16274240394318,
    monoisotopicMass: 156.07730157473,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  Clz: {
    name: '2-Chlorobenzyloxycarbonyl',
    mf: 'C8H6ClO2',
    ocl: {
      value: 'dcLDPDpEdXaImYgWYjB@@@',
      coordinates: '!BbOq^@Hb]bOrHgXc|Wb}^@Hb]bEu^Kp',
    },
    mass: 169.58527912946118,
    monoisotopicMass: 169.00563211451998,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 6 },
      { symbol: 'Cl', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Cp: {
    name: 'Cyclopentadienyl',
    mf: 'C5H5',
    ocl: { value: 'gFpH@liLimRp@', coordinates: '!B@IxlVrpXXDi`AP' },
    mass: 65.09338325395512,
    monoisotopicMass: 65.03912516115,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 5 },
    ],
  },
  Cys: {
    name: 'Cysteine diradical',
    mf: 'C3H5NOS',
    oneLetter: 'C',
    alternativeOneLetter: 'ς',
    ocl: {
      value: 'dazHpBPOEgG`aInVZjcH@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|b@H',
    },
    mass: 103.14280700237578,
    monoisotopicMass: 103.00918495955,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  Cysp: {
    name: 'Cysteine triradical',
    mf: 'C3H4NOS',
    ocl: {
      value: 'diFHHBD@f@agGoEIVVjjfLP@',
      coordinates: '!BMsrw_PElIvw_[C\\mxI^Gp',
    },
    mass: 102.13486624831998,
    monoisotopicMass: 102.00135992732,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 4 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  D: {
    name: 'Deuterium',
    mf: '[2H]',
    ocl: { value: 'eFAAYhBLCEH@', coordinates: '!B@Lt' },
    mass: 2.01410177812,
    monoisotopicMass: 2.01410177812,
    unsaturation: -1,
    elements: [{ symbol: 'H', number: 1, isotope: 2 }],
  },
  Dde: {
    name: 'Dde',
    mf: 'C10H13O2',
    ocl: {
      value: 'dklD`FDEgHhihicIVZfZj@@',
      coordinates: '!B`BH@k\\BbOw~@Oyb@Jw@h`B`BH@ox@',
    },
    mass: 165.20939861871415,
    monoisotopicMass: 165.09155465812998,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'O', number: 2 },
    ],
  },
  Dnp: {
    name: '2,4-Dinitrophenyl',
    mf: 'C6H3N2O4',
    ocl: {
      value: 'dkmB`bWatpVRd^VS{HhheEUFfBAbX@@',
      coordinates: '!BbOr~@Hb}erHHc|o`BWoXb}bOrHo[x@',
    },
    mass: 167.09926376274353,
    monoisotopicMass: 167.00928158383,
    unsaturation: 11,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 3 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 4 },
    ],
  },
  Et: {
    name: 'Ethyl',
    mf: 'C2H5',
    ocl: { value: 'eMBAYRZ@', coordinates: '!B@Fp@sP' },
    mass: 29.061175563749384,
    monoisotopicMass: 29.03912516115,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'H', number: 5 },
    ],
  },
  Fmoc: {
    name: 'Fluorenylmethoxycarbonyl',
    mf: 'C15H11O2',
    ocl: {
      value: 'fde@b@DX@liMkLrjxeVCzLuT@@@P@@@',
      coordinates: '!Bb@K~@Hc}b@JHTztMK@fRn{UKlZXAh_Fa@ilBfJ{lZX@',
    },
    mass: 223.24719659427882,
    monoisotopicMass: 223.07590459367,
    unsaturation: 19,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 2 },
    ],
  },
  For: {
    name: 'Formyl',
    mf: 'CHO',
    ocl: { value: 'eMJDVTfP@', coordinates: '!BbOp^@@' },
    mass: 29.018081575109303,
    monoisotopicMass: 29.0027396518,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 1 },
      { symbol: 'H', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Gln: {
    name: 'Glutamine diradical',
    mf: 'C5H8N2O2',
    oneLetter: 'Q',
    alternativeOneLetter: 'ξ',
    ocl: {
      value: 'dmUDPBUICqYqR[evfjihr@@',
      coordinates: '!BbKu^Gx`BlIu~@KC\\b@K~@H`BmpH',
    },
    mass: 128.12942178765059,
    monoisotopicMass: 128.05857750584,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  Glnp: {
    name: 'Glutamine triradical',
    mf: 'C5H7N2O2',
    ocl: {
      value: 'dcuDpH{MAYeqWqRVuejZjiad@',
      coordinates: '!Bb@JH_X`Bg~w_PElIvw_[C\\mxI^Gp',
    },
    mass: 127.12148103359483,
    monoisotopicMass: 127.05075247361,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
    ],
  },
  Glp: {
    name: 'Pyroglutamine',
    mf: 'C5H5NO2',
    ocl: {
      value: 'deVDPBRP|V\\TfygxYjjZL`@',
      coordinates: '!BBEu^kpa|BEtFPKXoAIP@mjAY',
    },
    mass: 111.09889631403748,
    monoisotopicMass: 111.03202840472,
    unsaturation: 6,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Glu: {
    name: 'Glutamic acid diradical',
    mf: 'C5H7NO3',
    oneLetter: 'E',
    alternativeOneLetter: 'ε',
    ocl: {
      value: 'dmVLPBRUCqYqR[evfjihr@@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|R@I~PI\\|POp',
    },
    mass: 129.11418274646732,
    monoisotopicMass: 129.04259308875,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Glup: {
    name: 'Glutamic acid triradical',
    mf: 'C5H6NO3',
    ocl: {
      value: 'dcvLpNcM@IeqWqRVuejZjiad@',
      coordinates: '!BmpH_Y\\|@S|w_REbEvwXc|mrI^Kp',
    },
    mass: 128.10624199241153,
    monoisotopicMass: 128.03476805652002,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Gly: {
    name: 'Glycine diradical',
    mf: 'C2H3NO',
    oneLetter: 'G',
    alternativeOneLetter: 'γ',
    ocl: { value: 'gGYDBaxuqR[Yj@@', coordinates: '!BxEu^_~AlxMw`[@' },
    mass: 57.051402191401905,
    monoisotopicMass: 57.021463720689994,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'H', number: 3 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Hci: {
    name: 'Homocitrulline diradical',
    mf: 'C7H13N3O2',
    ocl: {
      value: 'dgoDPBVtLOEgEInWUZZjjfcH@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|R@I~PD@BO`BH@ha}`@',
    },
    mass: 171.19730056284578,
    monoisotopicMass: 171.10077667142,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  Hcip: {
    name: 'Homocitrulline triradical',
    mf: 'C7H12N3O2',
    ocl: {
      value: 'do_DpHI\\\\EdwFEI[UVVijjjfIP@',
      coordinates: '!Bmww~_xa}mwuA_s}}@S|w_REbEvwXc|mrI^Kp',
    },
    mass: 170.18935980879002,
    monoisotopicMass: 170.09295163918998,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 2 },
    ],
  },
  His: {
    name: 'Histidine diradical',
    mf: 'C6H7N3O',
    oneLetter: 'H',
    alternativeOneLetter: 'ζ',
    ocl: {
      value: 'dcOHPBGTCqYqR[eyUvZjejL`@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|R@INpKBMhJXtQ@',
    },
    mass: 137.13951521745759,
    monoisotopicMass: 137.05891185847,
    unsaturation: 8,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  Hisp: {
    name: 'Histidine triradical',
    mf: 'C6H6N3O',
    ocl: {
      value: 'dkoHpHHSAYUqwqRY]YXjjVjihy@@',
      coordinates: '!Bwty}rDl{gyfOlc]}HW~HW[_}bOrwHexo',
    },
    mass: 136.13157446340182,
    monoisotopicMass: 136.05108682624,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  Hser: {
    name: 'Homoserine diradical',
    mf: 'C4H7NO2',
    ocl: {
      value: 'diFDPBPP|V\\Tfy^Zjhr@@',
      coordinates: '!BbEu^Kxc|bEu^@Hc|R@K~P@',
    },
    mass: 101.10404192541378,
    monoisotopicMass: 101.04767846918,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Hserp: {
    name: 'Homoserine triradical',
    mf: 'C4H6NO2',
    ocl: {
      value: 'defDpJbPV^\\Q|TeVVjji`d@',
      coordinates: '!Buww~Os]}HW~HW[_}bOrwHexo',
    },
    mass: 100.09610117135801,
    monoisotopicMass: 100.03985343695001,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Hyp: {
    name: 'Hydroxyproline diradical',
    mf: 'C5H7NO2',
    ocl: {
      value: 'deVDPBRP|V\\\\bfbbOCMUUIdE@@',
      coordinates: '!BBEu^kpa|BEtFPKXoAIP@m`IH',
    },
    mass: 113.11477782214904,
    monoisotopicMass: 113.04767846918,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Hypp: {
    name: 'Hydroxyproline triradical',
    mf: 'C5H6NO2',
    ocl: {
      value: 'dmvDpJaPB^\\Y|TeeWjZjjidRL`@',
      coordinates: '!BM{t}MsIO_E{jsdmf}w@w]BWn|',
    },
    mass: 112.10683706809326,
    monoisotopicMass: 112.03985343695001,
    unsaturation: 5,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Ile: {
    name: 'Isoleucine diradical',
    mf: 'C6H11NO',
    oneLetter: 'I',
    alternativeOneLetter: 'ι',
    ocl: {
      value: 'defHPBPOEgEInVyjjdrT`@',
      coordinates: '!BbIu^Kxc|bIu^@H`BqpJH@ex@',
    },
    mass: 113.15787181078912,
    monoisotopicMass: 113.08406397853,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Ivdde: {
    name: '1-[4,4-dimethyl-2,6-dioxocyclohexylidene)-3-methylbutyl',
    mf: 'C13H19O2',
    ocl: {
      value: 'f`a@b@NR@lyEEDhhigEVfjYjj`@@',
      coordinates: '!BH~hcy_x@H~k~\\rOj`pcyUseH~Tcy_xLgOeHwO~',
    },
    mass: 207.28925083325453,
    monoisotopicMass: 207.13850485151,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 19 },
      { symbol: 'O', number: 2 },
    ],
  },
  Leu: {
    name: 'Leucine diradical',
    mf: 'C6H11NO',
    oneLetter: 'L',
    alternativeOneLetter: 'λ',
    ocl: {
      value: 'defHPBPOEgEInWijjhr@@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|bOrHgUx@',
    },
    mass: 113.15787181078912,
    monoisotopicMass: 113.08406397853,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Lys: {
    name: 'Lysine diradical',
    mf: 'C6H12N2O',
    oneLetter: 'K',
    alternativeOneLetter: 'κ',
    ocl: {
      value: 'dmUHPBU@|V\\Tfy]YjjjL`@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|bOq^@Hc|bIt',
    },
    mass: 128.17251577629068,
    monoisotopicMass: 128.09496301519,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  Lysp: {
    name: 'Lysine triradical',
    mf: 'C6H11N2O',
    ocl: {
      value: 'dcuHpH{PVY\\U|TeUYZjjjXY@@',
      coordinates: '!BMwvwhk_}HW~wREbIvwXc|mzI^Kp',
    },
    mass: 127.16457502223491,
    monoisotopicMass: 127.08713798295999,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  Mbh: {
    name: "4,4'-Dimethoxybenzhydryl",
    mf: 'C15H15O2',
    ocl: {
      value: 'fdy@b@G^@liLsJkzlcZmT@@@UP@@@',
      coordinates: '!Bg~wXc}g~w@h`Bg~w[_}bOvH[\\Bg~wXc}mpJH@`',
    },
    mass: 227.27895961050194,
    monoisotopicMass: 227.10720472258998,
    unsaturation: 15,
    elements: [
      { symbol: 'C', number: 15 },
      { symbol: 'H', number: 15 },
      { symbol: 'O', number: 2 },
    ],
  },
  Me: {
    name: 'Methyl',
    mf: 'CH3',
    ocl: { value: 'eFBAYc@@', coordinates: '!B@AL' },
    mass: 15.03455815890258,
    monoisotopicMass: 15.02347509669,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 1 },
      { symbol: 'H', number: 3 },
    ],
  },
  Mebzl: {
    name: '4-Methylbenzyl',
    mf: 'C8H9',
    ocl: {
      value: 'did@`@VTee]nh@H@@',
      coordinates: '!BxFs`W^AlWg`w^A}Wg`WP',
    },
    mass: 105.15735396038399,
    monoisotopicMass: 105.07042529007,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 9 },
    ],
  },
  Meobzl: {
    name: '4-Methoxybenzyl',
    mf: 'C8H9O',
    ocl: {
      value: 'deTH`AAYRVUunh@J@@',
      coordinates: '!BxFs`WUyxFs`O^@}xFs`W^Al',
    },
    mass: 121.15675888470227,
    monoisotopicMass: 121.06533990964,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  Met: {
    name: 'Methionine diradical',
    mf: 'C5H9NOS',
    oneLetter: 'M',
    alternativeOneLetter: 'μ',
    ocl: {
      value: 'defHpBPOEgDPaInWYjjhr@@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|bGrHgXc|',
    },
    mass: 131.19604181206938,
    monoisotopicMass: 131.04048508847,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  Mmt: {
    name: '4-Methoxytrityl',
    mf: 'C20H17O',
    ocl: {
      value: 'ffcAB@B`V\\bdTTTRRRVvIhnRGMT@@@@AP@@@',
      coordinates:
        '!BmpJH@k\\Bg~@Hc}mw~@Hc}mvH@h`BmpJw@oyg~H__x@mvH@ha}',
    },
    mass: 273.3491156779715,
    monoisotopicMass: 273.12794016748,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 17 },
      { symbol: 'O', number: 1 },
    ],
  },
  Mtc: {
    name: '2,2,5,7,8-pentamethylchroman-6-sulphonyl',
    mf: 'C14H19O3S',
    ocl: {
      value: 'fleAa@DX\\AY`DYEHXhhilmiKW`rpDQUUD@@',
      coordinates: '!BmtBmvHmwvw@oymww~@K_}bOw~_x\\g~Opt|CSwqgvw',
    },
    mass: 267.36417906043516,
    monoisotopicMass: 267.10549064548,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 19 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  Mtr: {
    name: '4-Methoxy-2,3,6-trimethylbenzenesulphonyl',
    mf: 'C10H13O3S',
    ocl: {
      value: 'do|LPDrpVXBLbdLTTTngYXBHj@@',
      coordinates: '!Bmvw@ox@g~wXc}g~w@oyb@JH[_}g~HP',
    },
    mass: 213.27359094915948,
    monoisotopicMass: 213.05854045209998,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  Mts: {
    name: 'Mesitylene-2-sulphonyl',
    mf: 'C9H11O2S',
    mass: 183.24756861999438,
    monoisotopicMass: 183.04797576807,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'O', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  Mtt: {
    name: '4-Methyltrityl',
    mf: 'C20H17',
    mass: 257.3497107536532,
    monoisotopicMass: 257.13302554791,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 17 },
    ],
  },
  Nle: {
    name: 'Norleucine diradical',
    mf: 'C6H11NO',
    ocl: {
      value: 'defHPBPOEgEInWYjjhr@@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|bOq^@Hc|',
    },
    mass: 113.15787181078912,
    monoisotopicMass: 113.08406397853,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Npys: {
    name: '3-Nitro-2-pyridinesulphenyl',
    mf: 'C5H3N2O2S',
    ocl: { value: 'd@', coordinates: '' },
    mass: 155.1545054234988,
    monoisotopicMass: 154.99152351908998,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 3 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  Nva: {
    name: 'Norvaline diradical',
    mf: 'C5H9NO',
    ocl: {
      value: 'diFHPBPOEgEInWfjjL`@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|bOq^@@',
    },
    mass: 99.13125440594231,
    monoisotopicMass: 99.06841391407,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Odmab: {
    name: 'Odmab',
    mf: 'C20H26NO3',
    ocl: { value: 'd@', coordinates: '' },
    mass: 328.4260955245558,
    monoisotopicMass: 328.19126870111995,
    unsaturation: 15,
    elements: [
      { symbol: 'C', number: 20 },
      { symbol: 'H', number: 26 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 3 },
    ],
  },
  Orn: {
    name: 'Ornithine diradical',
    mf: 'C5H10N2O',
    ocl: {
      value: 'deeHPBe@|V\\Tfy]fjjcH@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|b@I^@Hc|',
    },
    mass: 114.14589837144388,
    monoisotopicMass: 114.07931295072999,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  Ornp: {
    name: 'Ornithine triradical',
    mf: 'C5H9N2O',
    ocl: {
      value: 'dmUHpHYPBQ\\Y|TeUejjjfJP@',
      coordinates: '!BMpJwREmwta_xb]mvHK^bWb|',
    },
    mass: 113.13795761738811,
    monoisotopicMass: 113.0714879185,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  Pbf: {
    name: '2,2,4,6,7-pentamethyldihydrobenzofurane-5-sulfonyl',
    mf: 'C13H17O3S',
    ocl: { value: 'd@', coordinates: '' },
    mass: 253.33756165558833,
    monoisotopicMass: 253.08984058101998,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 17 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  Pen: {
    name: 'Penicillamine diradical',
    mf: 'C5H9NOS',
    ocl: { value: 'd@', coordinates: '' },
    mass: 131.19604181206938,
    monoisotopicMass: 131.04048508847,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  Penp: {
    name: 'Penicillamine triradical',
    mf: 'C5H8NOS',
    mass: 130.1881010580136,
    monoisotopicMass: 130.03266005624,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
      { symbol: 'S', number: 1 },
    ],
  },
  Ph: {
    name: 'Phenyl',
    mf: 'C6H5',
    ocl: { value: 'gOpH@liLkW@@@@', coordinates: '!BxMw`[EyxMw`wUy' },
    mass: 77.10411915069038,
    monoisotopicMass: 77.03912516115,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 5 },
    ],
  },
  Phe: {
    name: 'Phenylalanine diradical',
    mf: 'C9H9NO',
    oneLetter: 'F',
    alternativeOneLetter: 'φ',
    ocl: {
      value: 'dknHPBPOEgEInWe]NZj@@cH@',
      coordinates: '!BbIu^Kxc|bIu^@Hc|bOs~PLa}rHKH`la}',
    },
    mass: 147.1741979928833,
    monoisotopicMass: 147.06841391407002,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Phepcl: {
    name: '4-Chlorophenylalanine diradical',
    mf: 'C9H8ClNO',
    ocl: {
      value: 'dg^HpBPOEgFxaInWe_Sfj`@bL`@',
      coordinates: '!BbIv^Sxc|bIv^@Hc|b@J^@Hb]bOrHH`]bOp',
    },
    mass: 181.6191948214355,
    monoisotopicMass: 181.02944156384,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 8 },
      { symbol: 'Cl', number: 1 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Phg: {
    name: 'Phenylglycine',
    mf: 'C8H7NO',
    ocl: {
      value: 'dcNHPBPOEgEInVuWYj`@Hr@@',
      coordinates: '!BJCVvz|a|rMUV@Dc|hwrH_EY@UdBH@',
    },
    mass: 133.1475805880365,
    monoisotopicMass: 133.05276384961002,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Pmc: {
    name: '2,2,5,7,8-Pentamethylchroman-6-sulphonyl',
    mf: 'C14H19O3S',
    mass: 267.36417906043516,
    monoisotopicMass: 267.10549064548,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 14 },
      { symbol: 'H', number: 19 },
      { symbol: 'O', number: 3 },
      { symbol: 'S', number: 1 },
    ],
  },
  Pro: {
    name: 'Proline diradical',
    mf: 'C5H7NO',
    oneLetter: 'P',
    alternativeOneLetter: 'π',
    ocl: {
      value: 'difHPBPOEgEInYxYjjhr@@',
      coordinates: '!BBEu^kpa|BEtFPKXoAIP@m`',
    },
    mass: 97.11537289783075,
    monoisotopicMass: 97.05276384961,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Pyr: {
    name: 'Pyroglutamine',
    mf: 'C5H5NO2',
    ocl: {
      value: 'deVDPBRP|V\\TfygxYjjZL`@',
      coordinates: '!BBEu^kpa|BEtFPKXoAIP@mjAY',
    },
    mass: 111.09889631403748,
    monoisotopicMass: 111.03202840472,
    unsaturation: 6,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Sar: {
    name: 'Sarcosine diradical',
    mf: 'C3H5NO',
    ocl: { value: 'd@', coordinates: '' },
    mass: 71.07801959624871,
    monoisotopicMass: 71.03711378515,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Ser: {
    name: 'Serine diradical',
    mf: 'C3H5NO2',
    oneLetter: 'S',
    alternativeOneLetter: 'σ',
    ocl: {
      value: 'dazDPBS`|V\\TfyYjjL`@',
      coordinates: '!BJCVvz|a|rMUV@Da|hwp',
    },
    mass: 87.07742452056698,
    monoisotopicMass: 87.03202840472,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 5 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Serp: {
    name: 'Serine triradical',
    mf: 'C3H4NO2',
    ocl: {
      value: 'diFDpB`PBV\\^|TeYZjjXq@@',
      coordinates: '!B`OR`cTyw`MW[]PBtVprvep',
    },
    mass: 86.06948376651121,
    monoisotopicMass: 86.02420337249,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 4 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Sta: {
    name: 'Statine diradical',
    mf: 'C8H15NO2',
    mass: 157.210511544801,
    monoisotopicMass: 157.11027872702002,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Stap: {
    name: 'Statine triradical',
    mf: 'C8H14NO2',
    mass: 156.2025707907452,
    monoisotopicMass: 156.10245369479,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Tacm: {
    name: 'Trimethylacetamidomethyl',
    mf: 'C6H12NO',
    mass: 114.16581256484488,
    monoisotopicMass: 114.09188901076,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Tbdms: {
    name: 't-Butyldimethylsilyl',
    mf: 'C6H15Si',
    mass: 115.2690253969541,
    monoisotopicMass: 115.09430201810001,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 6 },
      { symbol: 'H', number: 15 },
      { symbol: 'Si', number: 1 },
    ],
  },
  Tbu: {
    name: 't-Butyl',
    mf: 'C4H9',
    mass: 57.114410373442986,
    monoisotopicMass: 57.07042529007,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
    ],
  },
  Tbuo: {
    name: 't-Butoxy',
    mf: 'C4H9O',
    mass: 73.11381529776126,
    monoisotopicMass: 73.06533990964,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  Tbuthio: {
    name: 't-Butylthio',
    mf: 'C4H9S',
    mass: 89.17919777957005,
    monoisotopicMass: 89.04249646446999,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 9 },
      { symbol: 'S', number: 1 },
    ],
  },
  Tfa: {
    name: 'Trifluoroacetyl',
    mf: 'C2F3O',
    mass: 97.01608620597878,
    monoisotopicMass: 96.99012410776,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'F', number: 3 },
      { symbol: 'O', number: 1 },
    ],
  },
  Thr: {
    name: 'Threonine diradical',
    mf: 'C4H7NO2',
    oneLetter: 'T',
    alternativeOneLetter: 'τ',
    mass: 101.10404192541378,
    monoisotopicMass: 101.04767846918,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 7 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Thrp: {
    name: 'Threonine triradical',
    mf: 'C4H6NO2',
    mass: 100.09610117135801,
    monoisotopicMass: 100.03985343695001,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 4 },
      { symbol: 'H', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Tfsi: {
    name: '(Bis)(trifluoromethanesulfonyl)imide',
    mf: 'C2F6NO4S2',
    mass: 280.1457884908235,
    monoisotopicMass: 279.91729380789,
    unsaturation: -1,
    elements: [
      { symbol: 'C', number: 2 },
      { symbol: 'F', number: 6 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 4 },
      { symbol: 'S', number: 2 },
    ],
  },
  Tips: {
    name: 'Triisopropylsilyl',
    mf: 'C9H21Si',
    ocl: {
      value: 'dmT@P@VX\\DffYjjjh@@',
      coordinates: '!Bgd~GHc|gd~GgYx@bIv^@Hb]ayt',
    },
    mass: 157.34887761149452,
    monoisotopicMass: 157.14125221148,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 21 },
      { symbol: 'Si', number: 1 },
    ],
  },
  Tms: {
    name: 'Trimethylsilyl',
    mf: 'C3H9Si',
    ocl: { value: 'gJPD@lqpRZj`@', coordinates: '!BbOrHgYx@gd|' },
    mass: 73.1891731824137,
    monoisotopicMass: 73.04735182472,
    unsaturation: 1,
    elements: [
      { symbol: 'C', number: 3 },
      { symbol: 'H', number: 9 },
      { symbol: 'Si', number: 1 },
    ],
  },
  Tos: {
    name: 'Tosyl',
    mf: 'C7H7O2S',
    ocl: {
      value: 'dmtDPDpEf@cHiCDeafV@B@@',
      coordinates: '!BapJGgYyOg`BHH_|g`B^@H_|g`@',
    },
    mass: 155.1943338103008,
    monoisotopicMass: 155.01667563914998,
    unsaturation: 7,
    elements: [
      { symbol: 'C', number: 7 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 2 },
      { symbol: 'S', number: 1 },
    ],
  },
  Trp: {
    name: 'Tryptophan diradical',
    mf: 'C11H10N2O',
    oneLetter: 'W',
    alternativeOneLetter: 'ω',
    ocl: {
      value: 'f`qQA@BFPCqXxiMr|rnhsoSUTa@QCD@@',
      coordinates: '!BbIv^Sxc|bIv^@Hc|bOpv`MBupOhSaERDRfAJXAND',
    },
    mass: 186.21031375185538,
    monoisotopicMass: 186.07931295073,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  Trpp: {
    name: 'Tryptophan triradical',
    mf: 'C11H9N2O',
    ocl: {
      value: 'fhiQC@HFB@I\\x~|TfYU_ebLDjhDHjibFd@',
      coordinates: '!B{sZ]tGOkk|eJ@K^b\\}asvN^]R`B^G}B]yywPgN^\\ga|',
    },
    mass: 185.20237299779959,
    monoisotopicMass: 185.07148791850003,
    unsaturation: 15,
    elements: [
      { symbol: 'C', number: 11 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 1 },
    ],
  },
  Trt: {
    name: 'Trityl',
    mf: 'C19H15',
    ocl: {
      value: 'fbm@B@@KJSSLrjkyhnRGMT@@@@@@@@',
      coordinates: '!Bt{Uv@HautwWS_Ha|bGqvNwX{twqv@GX@bGVH]]MutwVH_GX{twp',
    },
    mass: 243.32309334880637,
    monoisotopicMass: 243.11737548345,
    unsaturation: 23,
    elements: [
      { symbol: 'C', number: 19 },
      { symbol: 'H', number: 15 },
    ],
  },
  Tyr: {
    name: 'Tyrosine diradical',
    mf: 'C9H9NO2',
    oneLetter: 'Y',
    alternativeOneLetter: 'ψ',
    ocl: {
      value: 'dg^DPBRp|V\\Tfy^U}NZj@BHr@@',
      coordinates: '!BbIv^Sxa|bIv^@Hc|bGr^@Hb]bGrHHb]bOp',
    },
    mass: 163.1736029172016,
    monoisotopicMass: 163.06332853364,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Tyrp: {
    name: 'Tyrosine triradical',
    mf: 'C9H8NO2',
    ocl: {
      value: 'do~DpEapBS\\[|Tee]YYnh@JjdbT@',
      coordinates: '!Bmrrwg[\\lgg~wo[^}gg~wwYyhKvwoZ@lm|r^_p',
    },
    mass: 162.16566216314578,
    monoisotopicMass: 162.05550350141,
    unsaturation: 11,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Val: {
    name: 'Valine',
    mf: 'C5H9NO',
    oneLetter: 'V',
    alternativeOneLetter: 'ν',
    ocl: {
      value: 'diFHPBPOEgEInVfjjL`@',
      coordinates: '!BbIv^Sxc|bIv^@Hc|bOrG@',
    },
    mass: 99.13125440594231,
    monoisotopicMass: 99.06841391407,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 1 },
    ],
  },
  Valoh: {
    name: 'beta-Hydroxyvaline diradical',
    mf: 'C5H9NO2',
    ocl: {
      value: 'defDPBS`|V\\TfyZfjjcH@',
      coordinates: '!BbIv^Sxc|bIv^@Hc|g`BHH_|',
    },
    mass: 115.13065933026058,
    monoisotopicMass: 115.06332853364,
    unsaturation: 2,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 9 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Valohp: {
    name: 'beta-Hydroxyvaline triradical',
    mf: 'C5H8NO2',
    ocl: {
      value: 'dmVDpFaPBQ\\Y|\\bTbaTjjjXq@@',
      coordinates: '!BhIv^_yyhBrwKJB]myv`KK_Lgg|',
    },
    mass: 114.1227185762048,
    monoisotopicMass: 114.05550350141002,
    unsaturation: 3,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 8 },
      { symbol: 'N', number: 1 },
      { symbol: 'O', number: 2 },
    ],
  },
  Xan: {
    name: 'Xanthyl',
    mf: 'C13H9O',
    ocl: { value: 'd@', coordinates: '' },
    mass: 181.21043836837848,
    monoisotopicMass: 181.06533990964002,
    unsaturation: 17,
    elements: [
      { symbol: 'C', number: 13 },
      { symbol: 'H', number: 9 },
      { symbol: 'O', number: 1 },
    ],
  },
  Z: {
    name: 'Benzyloxycarbonyl',
    mf: 'C8H7O2',
    ocl: {
      value: 'dmtD`DpEeImYVUfh@@@@',
      coordinates: '!BbOq^@Ha]bOrHWXc|Wb~HWXb]Wb|',
    },
    mass: 135.14028230090898,
    monoisotopicMass: 135.04460446475,
    unsaturation: 9,
    elements: [
      { symbol: 'C', number: 8 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 2 },
    ],
  },
  Damp: {
    name: 'Desoxyadenosine monophosphate diradical',
    mf: 'C10H12N5O5P',
    oneLetter: 'A',
    alternativeOneLetter: 'α',
    ocl: {
      value: 'fnsiS@IASUlJB]xGbkplxyDhhldhiEEUeSdTekUUUULBATXPlKd@@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOs}[K`|fKUNTDy[ZzDR|Hfp[RSmIAKpDo@',
    },
    mass: 313.2069506932622,
    monoisotopicMass: 313.05760550518,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 5 },
      { symbol: 'P', number: 1 },
    ],
  },
  Dcmp: {
    name: 'Desoxycytidine monophosphate diradical',
    mf: 'C9H12N3O6P',
    oneLetter: 'C',
    alternativeOneLetter: 'ς',
    ocl: {
      value: 'fjmps@IQKB`g^BCqUxV\\\\bTTVRTTbb^iqNZjjjifVkBEa\\`@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BfKUNTDy[bqVvtK[Pz@Jvt@',
    },
    mass: 289.18221329795364,
    monoisotopicMass: 289.04637211589,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  Dgmp: {
    name: 'Desoxyguanosine monophosphate diradical',
    mf: 'C10H12N5O6P',
    oneLetter: 'G',
    alternativeOneLetter: 'γ',
    ocl: {
      value: 'fakhs@IASUlJB]{hOEWaYqrIQQYIQRJJkQTyEIZuUUUSRtsUaBpnP@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOs}[K`|fKUNTDy[ZzDR|Hfp[RQmIAKpNrDR|@',
    },
    mass: 329.20635561758047,
    monoisotopicMass: 329.05252012475,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  Dtmp: {
    name: 'Desoxythymidine monophosphate diradical',
    mf: 'C10H13N2O7P',
    oneLetter: 'T',
    alternativeOneLetter: 'τ',
    ocl: {
      value: 'ff}Qs@IQaPSoAjCqUxV\\\\bTTVRTTbbZUNIsUUUULsSVDKBy@@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BfKUNTDy[bqVvtK[Pz@Kh@k[P',
    },
    mass: 304.1935916616171,
    monoisotopicMass: 304.04603776326,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  Dump: {
    name: 'Desoxyuridine monophosphate diradical',
    mf: 'C9H11N2O7P',
    oneLetter: 'U',
    alternativeOneLetter: 'υ',
    ocl: {
      value: 'fjmQs@IQaPSoAJCqUxV\\\\bTTVRTTbb^iqNZjjjifYkBEa\\`@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BfKUNTDy[bqVvtK[Pz@Jvt@',
    },
    mass: 290.1669742567703,
    monoisotopicMass: 290.0303876988,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  Drmp: {
    name: 'Desoxyribose monophosphate diradical',
    mf: 'C5H7O5P',
    mass: 178.08005138207807,
    monoisotopicMass: 178.00311032188,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 5 },
      { symbol: 'P', number: 1 },
    ],
  },
  Dadp: {
    name: 'Desoxyadenosine diphosphate diradical',
    mf: 'C10H13N5O8P2',
    ocl: {
      value: 'fmwhH`IASM\\JBl{wQ`|U^F_AkbdlsjsSOoRtyEMYuUUUM@pSEQaBpnP@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOs}[K`|SeBXmTy[ZzDR|HfpfOsmINtdfKUNTDy[Do@R|@',
    },
    mass: 393.1868682186928,
    monoisotopicMass: 393.02393639454,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 2 },
    ],
  },
  Dcdp: {
    name: 'Desoxycytidine diphosphate diradical',
    mf: 'C9H13N3O9P2',
    ocl: {
      value: 'fikqH`IQGB`kN|EoP^JoCOaUqrIQQYIQRJKGRJgDejjjjZYfZkBEa\\`@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BSeBXmTy[bqVvtK[PfOsh@ibuSeANV{[P',
    },
    mass: 369.16213082338425,
    monoisotopicMass: 369.01270300525005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 2 },
    ],
  },
  Dgdp: {
    name: 'Desoxyguanosine diphosphate diradical',
    mf: 'C10H13N5O9P2',
    ocl: {
      value: 'fcoiH`IASM\\JBl{wQ{Axj|L~CWEIYgUff_^fZ\\bflzjjjfiZifZlHVEr@@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOs}[K`|SeBXmTy[ZzDR|HfpfOsmINtdfKUNTDy[Do@{HQKp',
    },
    mass: 409.186273143011,
    monoisotopicMass: 409.01885101411,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 2 },
    ],
  },
  Dtdp: {
    name: 'Desoxythymidine diphosphate diradical',
    mf: 'C10H14N2O10P2',
    ocl: {
      value: 'fe{Ph`IQaPUg^Ct\\p^JoCO`uqrIQQYIQRJKEJQTxdmUUUSSMTsVDKBy@@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BSeBXmTy[bqVvtK[PfOsh@n`BfKUNTDy[mm@',
    },
    mass: 384.1735091870477,
    monoisotopicMass: 384.01236865262,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  Dudp: {
    name: 'Desoxyuridine diphosphate diradical',
    mf: 'C9H12N2O10P2',
    ocl: {
      value: 'fikPh`IQaPUg^Bwhp^JoCOaUqrIQQYIQRJKGRJgDejjjjZYjYkBEa\\`@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BSeBXmTy[bqVvtK[PfOsh@ibuSeANV{[P',
    },
    mass: 370.1468917822009,
    monoisotopicMass: 369.99671858816,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  Datp: {
    name: 'Desoxyadenosine triphosphate diradical',
    mf: 'C10H14N5O11P3',
    ocl: {
      value:
        'eohZMJ@I@diehJAKGOFnakg`OESpr|Mo@yqrIQQYIQRJKYZQKVRcbIJjZjjjihFAhjZcAAXKb@@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOs}[K`|SeBXmTy[ZzDR|HfpfOsmINtdSeBXmTy[Do@R|Ic|fKUNTDy[',
    },
    mass: 473.16678574412344,
    monoisotopicMass: 472.9902672839,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 3 },
    ],
  },
  Dctp: {
    name: 'Desoxycytidine triphosphate diradical',
    mf: 'C9H14N3O12P3',
    ocl: {
      value:
        'fkopZ`IQGB`kN|Fk^{NCqUxY|I~BwGHeEEdeEHhl]HlYJ\\RVjjjiifVjfkBEa\\`@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqS_N`BSeBXmTy[bqVvtK[PfOsh@dyPfKUNV{[PfOrXmTyPSel',
    },
    mass: 449.14204834881485,
    monoisotopicMass: 448.97903389461004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 3 },
    ],
  },
  Dgtp: {
    name: 'Desoxyguanosine triphosphate diradical',
    mf: 'C10H14N5O12P3',
    ocl: {
      value:
        'e`TZCJ@I@diehJAKGOFnamgo`OESpr|CoByqrIQQYIQRJKYZQQYrT\\QIUSUUUUMRuMLtuVBBpWD@@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOs}[K`|SeBXmTy[ZzDR|HfpfOqmIFtdSeBXmTy[Do@{HQKpfOrXmTyPSel',
    },
    mass: 489.16619066844174,
    monoisotopicMass: 488.98518190347005,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 3 },
    ],
  },
  Dttp: {
    name: 'Desoxythymidine triphosphate diradical',
    mf: 'C10H15N2O13P3',
    ocl: {
      value:
        'fgQZ`IQaPUg^BwhygnCqUxY|E~FwGHeEEdeEHhlTiDSISbRuUUUMLuMMMVDKBy@@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BSeBXmTy[bqVvtK[PfOsh@n`BSeBXmTy[mmBXIbuSeANVp',
    },
    mass: 464.15342671247834,
    monoisotopicMass: 463.97869954198,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  Dutp: {
    name: 'Desoxyuridine triphosphate diradical',
    mf: 'C9H13N2O13P3',
    ocl: {
      value:
        'fkoQZ`IQaPUg^CUoQ{NCqUxY|I~BwGHeEEdeEHhl]HlYJ\\RVjjjiiffffkBEa\\`@',
      coordinates:
        '!BjeBM^IIpJwY}gGBRrW@XUSX@fOqSN`BSeBXmTy[bqVvtK[PfOsh@dyPfKUNV{[PfOrXmTyPSel',
    },
    mass: 450.1268093076315,
    monoisotopicMass: 449.96304947752,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  Dade: {
    name: 'Desoxyadenosine diradical',
    mf: 'C10H11N5O2',
    ocl: {
      value: 'fluha@IF]ELJ@|QNJRsN|rntyYpXuUUTBATXPlKd@@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@VrxOFnaDoBIlFtd[RPR|AKp',
    },
    mass: 233.22703316783156,
    monoisotopicMass: 233.09127461582,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 2 },
    ],
  },
  Dcyt: {
    name: 'Desoxycytidine diradical',
    mf: 'C9H11N3O3',
    ocl: {
      value: 'fhiqa@IVCBa`^HgEIYg^Y~gG^jjjiejpaXWH@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@HwpX_BNU]aAvDAc|]a@',
    },
    mass: 209.202295772523,
    monoisotopicMass: 209.08004122653,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 3 },
    ],
  },
  Dgua: {
    name: 'Desoxyguanosine diradical',
    mf: 'C10H11N5O3',
    ocl: {
      value: 'fbmia@IF]ELJYAxb\\Tef]ye^Z\\lxLZjjjeZfkBEa\\`@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@VrxOFnaDoBIlNtd{RPR|FnaDo@',
    },
    mass: 249.22643809214986,
    monoisotopicMass: 249.08618923539,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 3 },
    ],
  },
  Dthy: {
    name: 'Desoxythymidine diradical',
    mf: 'C10H12N2O4',
    ocl: {
      value: 'fdyPQ@IVaPtP^HgEIYg^YuiqwjjjjYikBEa\\`@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@HwpX_BNU]aAvDAc|FOqvD@',
    },
    mass: 224.2136741361865,
    monoisotopicMass: 224.07970687390002,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 4 },
    ],
  },
  Dura: {
    name: 'Desoxyuridine diradical',
    mf: 'C9H10N2O4',
    ocl: {
      value: 'fhiPQ@IVaPpP^HgEIYg^Y~gG^jjjifZpaXWH@',
      coordinates: '!BjeBM^IIpJwY}gGBRrW@XUSX@HpXBNU]aAvDAc|]a@',
    },
    mass: 210.1870567313397,
    monoisotopicMass: 210.06405680944,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 4 },
    ],
  },
  Amp: {
    name: 'Adenosine monophosphate diradical',
    mf: 'C10H12N5O6P',
    oneLetter: 'A',
    alternativeOneLetter: 'α',
    ocl: {
      value: 'fakhs@INBwlJ\\TgHOFwaEqrIQQSYQJIRIMLyxMVuUUUPLpEPQDqBId@@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEW}[K`|fOqkhQKpb[BXmTyPSeomIFtdDo@R|@',
    },
    mass: 329.20635561758047,
    monoisotopicMass: 329.05252012475,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  Cmp: {
    name: 'Cytidine monophosphate diradical',
    mf: 'C9H12N3O7P',
    oneLetter: 'C',
    alternativeOneLetter: 'ς',
    ocl: {
      value: 'ff}qs@I^kBgENSdGc[pbxyDhhilheDiLv\\BVjjjjYfZbHfHQL`@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUSN`BfOrKE[[PmmBXmTyPSeoh@k[P',
    },
    mass: 305.1816182222719,
    monoisotopicMass: 305.04128673546,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  Gmp: {
    name: 'Guanosine monophosphate diradical',
    mf: 'C10H12N5O7P',
    oneLetter: 'G',
    alternativeOneLetter: 'γ',
    ocl: {
      value: 'fi{is@INBwlJ\\TgHp^MoBKcdRbbfrbTRdR\\SN^CUmUUUUKMSMQDSDHfP@',
      coordinates:
        '!BjeBM^BmvdgBM_\\ep_YqpdcX@FEW}[K`|fOqkhQKpb[BXmTyPSeomINtdDo@{HQKp',
    },
    mass: 345.20576054189877,
    monoisotopicMass: 345.04743474432,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 7 },
      { symbol: 'P', number: 1 },
    ],
  },
  Tmp: {
    name: 'Thymidine monophosphate diradical',
    mf: 'C10H13N2O8P',
    oneLetter: 'T',
    alternativeOneLetter: 'τ',
    ocl: {
      value: 'fncPK@I^aSbgIrtGc[pbxyDhhilheDiLjs`RuUUUSLuMDQLPbY@@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUSN`BfOrKE[[PmmBXmTyPSeoh@n`Bmm@',
    },
    mass: 320.1929965859354,
    monoisotopicMass: 320.04095238282997,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  Ump: {
    name: 'Uridine monophosphate diradical',
    mf: 'C9H11N2O8P',
    oneLetter: 'U',
    alternativeOneLetter: 'υ',
    ocl: {
      value: 'ff}PK@I^aSbgIsTGc[pbxyDhhilheDiLv\\BVjjjjYffbHfHQL`@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUSN`BfOrKE[[PmmBXmTyPSeoh@k[P',
    },
    mass: 306.1663791810886,
    monoisotopicMass: 306.02530231837,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 8 },
      { symbol: 'P', number: 1 },
    ],
  },
  Rmp: {
    name: 'Ribose monophosphate diradical',
    mf: 'C5H7O6P',
    mass: 194.07945630639637,
    monoisotopicMass: 193.99802494145,
    unsaturation: 4,
    elements: [
      { symbol: 'C', number: 5 },
      { symbol: 'H', number: 7 },
      { symbol: 'O', number: 6 },
      { symbol: 'P', number: 1 },
    ],
  },
  Adp: {
    name: 'Adenosine diphosphate diradical',
    mf: 'C10H13N5O9P2',
    ocl: {
      value:
        'fcoiH`INCt\\J\\UENU{Axv|F~DwGHeEEMeDheHd\\eHsg`u{UUUU@mAEMPQDqBId@@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEW}[K`|fOqkhQKpb[ANTIbuSemmIFtdfOpR|AKpfKUNTDy[',
    },
    mass: 409.186273143011,
    monoisotopicMass: 409.01885101411,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 9 },
      { symbol: 'P', number: 2 },
    ],
  },
  Cdp: {
    name: 'Cytidine diphosphate diradical',
    mf: 'C9H13N3O10P2',
    ocl: {
      value: 'fe{ph`I^[BgENbgHy`|[^E_CkcdRbbfrbTRdqrdYpIZjjjieijZbHfHQL`@',
      coordinates:
        '!BjeBM^BmvdgBM_\\ep_YqpdcX@FEUSN`BfOrKE[[PmmANTIbuSeoh@ic|mmBXmTyPSel',
    },
    mass: 385.1615357477025,
    monoisotopicMass: 385.00761762482,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  Gdp: {
    name: 'Guanosine diphosphate diradical',
    mf: 'C10H13N5O10P2',
    ocl: {
      value:
        'fkhh`INCt\\J\\UENY{NCqmxM|EnNQJJJ[JIQJQHzIRLyxM^uUUUTkUSLuQDSDHfP@',
      coordinates:
        '!BjeBM^BmvdgBM_\\ep_YqpdcX@FEW}[K`|fOqkhQKpb[ANTIbuSemmIFtdfOpR|ClaDoBXmTyPSel',
    },
    mass: 425.1856780673293,
    monoisotopicMass: 425.01376563368,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 10 },
      { symbol: 'P', number: 2 },
    ],
  },
  Tdp: {
    name: 'Thymidine diphosphate diradical',
    mf: 'C10H14N2O11P2',
    ocl: {
      value: 'fmgQh`I^aSbgQSglu`|[^C_@[bdls^rruo}LxDmUUUTruTsTQDqBId@@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUS_N`BfOrKE[[PmmANTIbuSeoh@n`BfOrvtIbuSeANVp',
    },
    mass: 400.172914111366,
    monoisotopicMass: 400.00728327219,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 2 },
    ],
  },
  Udp: {
    name: 'Uridine diphosphate diradical',
    mf: 'C9H12N2O11P2',
    ocl: {
      value: 'fe{Qh`I^aSbgQSehy`|[^E_CkcdRbbfrbTRdqrdYpIZjjjiejfZbHfHQL`@',
      coordinates:
        '!BjeBM^BmvdgBM_\\ep_YqpdcX@FEUSN`BfOrKE[[PmmANTIbuSeoh@ic|mmBXmTyPSel',
    },
    mass: 386.14629670651925,
    monoisotopicMass: 385.99163320773005,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 11 },
      { symbol: 'P', number: 2 },
    ],
  },
  Atp: {
    name: 'Adenosine triphosphate diradical',
    mf: 'C10H14N5O12P3',
    ocl: {
      value:
        'e`TZCJ@IG@nahJNEHdliemgo`OFspZ|CoByqrIQQSYQJIRIGIRWRL\\^AU]UUUUPKPQMTuABDpaBX`@',
      coordinates:
        '!BjeBM^BmvdgBM_\\ep_YqpdcX@FEW}[K`|fOqkhQKpb[ANTIbuSeomINtdfOpR|AKpSeBXmTy[fOrXmTyPSel',
    },
    mass: 489.16619066844174,
    monoisotopicMass: 488.98518190347005,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 12 },
      { symbol: 'P', number: 3 },
    ],
  },
  Ctp: {
    name: 'Cytidine triphosphate diradical',
    mf: 'C9H14N3O13P3',
    ocl: {
      value:
        'fgqZ`I^[BgENbgOQsO\\Gc[pkxK|MnNQJJJ[JIQJSGJPzQg@ejjjjfVffjZbHfHQL`@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUS_N`BfOrKE[[PmmANTIbuSeoh@ic|mmANTIbuSenX_IbuSeANVp',
    },
    mass: 465.1414532731331,
    monoisotopicMass: 464.97394851418,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  Gtp: {
    name: 'Guanosine triphosphate diradical',
    mf: 'C10H14N5O13P3',
    ocl: {
      value:
        'eh\\ZKJ@IG@nahJNEHdliemco`POFspZ|KoAyqrIQQSYQJIRIGQJQzQccpJkjjjjjeZjYZijbDIaBDq@@',
      coordinates:
        '!BjeBM^BmvdgBM_\\ep_YqpdcX@FEW}[K`|fOqkhQKpb[ANTIbuSemmINtdfOpR|ClaDoANTIbuSenXIbuSeANVp',
    },
    mass: 505.16559559276,
    monoisotopicMass: 504.98009652304,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 14 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 13 },
      { symbol: 'P', number: 3 },
    ],
  },
  Ttp: {
    name: 'Thymidine triphosphate diradical',
    mf: 'C10H15N2O14P3',
    ocl: {
      value:
        'eo`TGJ@IOHJNEGHdlnaiekg`OFspZ|Mo@yqrIQQSYQJIRY[ZPzQc`HjjjjjYZjVjZbDIaBDq@@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUS_N`BfOrKE[[PmmANTIbuSeoh@n`BfOrvtDyPfKUNVyc|fKUNTDy[',
    },
    mass: 480.15283163679663,
    monoisotopicMass: 479.97361416155,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 15 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 14 },
      { symbol: 'P', number: 3 },
    ],
  },
  Utp: {
    name: 'Uridine triphosphate diradical',
    mf: 'C9H13N2O14P3',
    ocl: {
      value:
        'fgPz`I^aSbgQSeoQsO\\Gc[pkxK|MnNQJJJ[JIQJSGJPzQg@ejjjjfVjVjZbHfHQL`@',
      coordinates:
        '!BjeBM^BmvdgBM\\ep_YqpdcX@FEUS_N`BfOrKE[[PmmANTIbuSeoh@ic|mmANTIbuSenX_IbuSeANVp',
    },
    mass: 466.12621423194986,
    monoisotopicMass: 465.95796409709004,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 13 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 14 },
      { symbol: 'P', number: 3 },
    ],
  },
  Ade: {
    name: 'Adenosine diradical',
    mf: 'C10H11N5O3',
    ocl: {
      value: 'fbmia@IV|gLJ\\Axj\\Tef[vyWV\\]zJZjjj`PJ`bIbDSH@',
      coordinates: '!BjeBM^BmvdgBM\\ep_YqpdcX@FEW}[K`|ZzDR|Hfp[RSmIAKpDo@',
    },
    mass: 249.22643809214986,
    monoisotopicMass: 249.08618923539,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 3 },
    ],
  },
  Cyt: {
    name: 'Cytidine diradical',
    mf: 'C9H11N3O4',
    ocl: {
      value: 'fdypQ@INcBgK@|UNJRsM{\\~sg`uUUULmQDSDHfP@',
      coordinates: '!BjeBM^BmvdgBM\\ep_YqpdcX@FETcAc|HyUvDGXPFOqvD@',
    },
    mass: 225.20170069684127,
    monoisotopicMass: 225.0749558461,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 3 },
      { symbol: 'O', number: 4 },
    ],
  },
  Gua: {
    name: 'Guanosine diradical',
    mf: 'C10H11N5O4',
    ocl: {
      value: 'fj}hQ@IV|gLJ\\JCqTxiKLwmroKNN}EMUUUTkTuDQLPbY@@',
      coordinates: '!BjeBM^BmvdgBM\\ep_YqpdcX@FEW}[K`|ZzDR|Hfp[RSmIAKpZzDR|@',
    },
    mass: 265.22584301646816,
    monoisotopicMass: 265.08110385496,
    unsaturation: 14,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 11 },
      { symbol: 'N', number: 5 },
      { symbol: 'O', number: 4 },
    ],
  },
  Thy: {
    name: 'Thymidine diradical',
    mf: 'C10H12N2O5',
    ocl: {
      value: 'fleQQ@INaSed`|UNJRsM{\\zlyxMUUUSMMDQLPbY@@',
      coordinates: '!BjeBM^BmvdgBM\\ep_YqpdcX@FETcAc|HyUvDGXPFOpXGXP',
    },
    mass: 240.21307906050478,
    monoisotopicMass: 240.07462149347,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 10 },
      { symbol: 'H', number: 12 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 5 },
    ],
  },
  Ura: {
    name: 'Uridine diradical',
    mf: 'C9H10N2O5',
    ocl: {
      value: 'fdyQQ@INaSeh`|UNJRsM{\\~sg`uUUULsQDSDHfP@',
      coordinates: '!BjeBM^BmvdgBM\\ep_YqpdcX@FETcAc|HyUvDGXPFOqvD@',
    },
    mass: 226.18646165565798,
    monoisotopicMass: 226.05897142901,
    unsaturation: 10,
    elements: [
      { symbol: 'C', number: 9 },
      { symbol: 'H', number: 10 },
      { symbol: 'N', number: 2 },
      { symbol: 'O', number: 5 },
    ],
  },
};
